// extracted by mini-css-extract-plugin
module.exports = {"wishlistModalOrderDetails":"WishlistModalOrderDetails_wishlistModalOrderDetails__yljjO"};